export interface Skills {
    a?: number;
    b?: number;
    c?: number;

    d?: number;
    e?: number;
    f?: number;

    g?: number;
    h?: number;
    i?: number;

    j?: number;
    k?: number;
    l?: number;

    m?: number;
    n?: number;
    o?: number;
}

export function add(first: Skills, second: Skills): Skills {
    return {
        a: (first?.a ?? 0) + (second?.a ?? 0),
        b: (first?.b ?? 0) + (second?.b ?? 0),
        c: (first?.c ?? 0) + (second?.c ?? 0),

        d: (first?.d ?? 0) + (second?.d ?? 0),
        e: (first?.e ?? 0) + (second?.e ?? 0),
        f: (first?.f ?? 0) + (second?.f ?? 0),

        g: (first?.g ?? 0) + (second?.g ?? 0),
        h: (first?.h ?? 0) + (second?.h ?? 0),
        i: (first?.i ?? 0) + (second?.i ?? 0),

        j: (first?.j ?? 0) + (second?.j ?? 0),
        k: (first?.k ?? 0) + (second?.k ?? 0),
        l: (first?.l ?? 0) + (second?.l ?? 0),

        m: (first?.m ?? 0) + (second?.m ?? 0),
        n: (first?.n ?? 0) + (second?.n ?? 0),
        o: (first?.o ?? 0) + (second?.o ?? 0),
    }
}

export function apply(value: Skills, skillFunc: (skillValue: number) => number): Skills {
    return {
        a: skillFunc(value.a ?? 0),
        b: skillFunc(value.b ?? 0),
        c: skillFunc(value.c ?? 0),

        d: skillFunc(value.d ?? 0),
        e: skillFunc(value.e ?? 0),
        f: skillFunc(value.f ?? 0),

        g: skillFunc(value.g ?? 0),
        h: skillFunc(value.h ?? 0),
        i: skillFunc(value.i ?? 0),

        j: skillFunc(value.j ?? 0),
        k: skillFunc(value.k ?? 0),
        l: skillFunc(value.l ?? 0),

        m: skillFunc(value.m ?? 0),
        n: skillFunc(value.n ?? 0),
        o: skillFunc(value.o ?? 0),
    }
}

export const EMPTY_SKILLS: Skills = Object.freeze({
    a: 0,
    b: 0,
    c: 0,

    d: 0,
    e: 0,
    f: 0,

    g: 0,
    h: 0,
    i: 0,

    j: 0,
    k: 0,
    l: 0,

    m: 0,
    n: 0,
    o: 0
});

export function sum(userLevels: Skills): number {
    let totalLevel = 0;
    apply(userLevels, (skillValue) => {
        totalLevel += skillValue ?? 0;
        return skillValue ?? 0
    });
    return totalLevel;
}

export function xpFromLevel(level: number = 0): number {
    let cumulativeXp = 0;
    for (let i = 0; i < level; i++) {
        cumulativeXp += 10 + Math.floor((i + 1) / 10);
    }
    return cumulativeXp;
}

export function xpToLevel(xp: number = 0): number {
    let cumulativeXp = 0;
    for (let i = 0; i < 100; i++) {
        cumulativeXp += 10 + Math.floor((i + 1) / 10);
        if (xp < cumulativeXp) {
            return i;
        }
    }
    return 99;
}
